import {AppDispatch} from "../index"
import {handbookSlice} from "../slices/handbookSlice"
import $api from "../../axios"
import {employeeRoles, employeeStatus} from "../../models/handbook"

export const fetchHandbooks = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(handbookSlice.actions.fetching())

    const response = await Promise.all([
      $api.get<employeeRoles>("employee/employee/get-roles"),
      $api.get<employeeStatus[]>("employee/employee/get-statuses")
    ])

    dispatch(handbookSlice.actions.fetchSuccess({
      employeeRoles: response[0].data,
      employeeStatuses: response[1].data
    }))

  } catch (e: any) {
    dispatch(handbookSlice.actions.fetchError(e))
  }
}